import React, { useContext, useState, useEffect, createContext } from 'react'

// import { GoogleAuthProvider } from "firebase/auth";
import { User } from 'firebase/auth'
import { authStateListener } from '@/features/auth/services/authService'

interface AuthContextType {
  userLoggedIn: boolean
  isEmailUser: boolean
  isGoogleUser: boolean
  currentUser: User | null
  setCurrentUser: React.Dispatch<React.SetStateAction<User | null>>
}

const AuthContext = createContext<AuthContextType>({
  userLoggedIn: false,
  isEmailUser: false,
  isGoogleUser: false,
  currentUser: null,
  setCurrentUser: () => null
})

export function useAuth() {
  return useContext(AuthContext)
}

interface AuthProviderProps {
  children: React.ReactNode
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [currentUser, setCurrentUser] = useState<User | null>(null)
  const [userLoggedIn, setUserLoggedIn] = useState(false)
  const [isEmailUser, setIsEmailUser] = useState(false)
  const [isGoogleUser] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const unsubscribe = authStateListener(initializeUser)
    return unsubscribe
  }, [])

  async function initializeUser(user: User | null) {
    if (user) {
      setCurrentUser({ ...user })

      // check if provider is email and password login
      const isEmail = user.providerData.some(
        provider => provider.providerId === 'password'
      )
      setIsEmailUser(isEmail)

      // check if the auth provider is google or not
      // const isGoogle = user.providerData.some(
      //   (provider) => provider.providerId === GoogleAuthProvider.PROVIDER_ID
      // );
      // setIsGoogleUser(isGoogle);

      setUserLoggedIn(true)
    } else {
      setCurrentUser(null)
      setUserLoggedIn(false)
    }

    setLoading(false)
  }

  const value = React.useMemo(
    () => ({
      userLoggedIn,
      isEmailUser,
      isGoogleUser,
      currentUser,
      setCurrentUser
    }),
    [userLoggedIn, isEmailUser, isGoogleUser, currentUser]
  )

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  )
}
